<template>
    <div class="options-container">
        <ul v-if="!disabled">
            <li
              v-for="pokemon in pokemons"
              :key="pokemon.id"
              @click="$emit('selection', pokemon.id )"
              class="pokemonOption">
              {{ pokemon.name }}
              </li>
        </ul>
    </div>
</template>

<script>

export default {
    props: {
        pokemons: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        }
    },
}
</script>

<style scoped>

    ul {
        list-style-type: none;
        width: 300px;
        padding-left: 0;
    }

    li {
        align-items: center;
        background-color: white;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        cursor: pointer;
        display: flex;
        height: 30px;
        justify-content: center;
        margin-bottom: 10px;
        border: 1px solid black;
    }

    li:hover {
        background-color: rgba(255, 254, 254, 0.7);
    }

    .options-container {
        display: flex;
        justify-content: center;
        margin-top: 10px
    }

    @media (max-width: 600px){

        ul{
            margin-top: 0;
        }

        li{
            height: 25px;
        }
    }

</style>